import { Box, Button } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function ReadAllButton() {
    const { showMore, setShowMore } = useBoundContext()
    return (
        <Box textAlign={"right"}>
            <Button
                size="small"
                sx={{ p: 0, alignItems: "center", textTransform: "lowercase" }}
                onClick={() => setShowMore(!showMore)}
                data-cy="read-all-button"
            >
                {showMore ? "...read less" : "...read all"}
            </Button>
        </Box>
    )
}
